// STORAGE KEYS
export const STORAGE_KEYS = {
	TOKEN: process.env.REACT_APP_TOKEN_KEY || 'stichmaster_token',
} as const;

// ENVIRONMENT VARIABLES
export const ENV = {
	API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
	SITE_NAME: process.env.REACT_APP_SITE_NAME || 'StichMaster',
	PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR || '#0E5F98',
	MODERN_DESIGN: process.env.REACT_APP_MODERN_DESGIN === 'true',
	ASIDE_WIDTH_PX: Number(process.env.REACT_APP_ASIDE_WIDTH_PX) || 195,
	SPACER_PX: Number(process.env.REACT_APP_SPACER_PX) || 13,
	MOBILE_BREAKPOINT_SIZE: Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE) || 768,
	ASIDE_MINIMIZE_BREAKPOINT_SIZE:
		Number(process.env.REACT_APP_ASIDE_MINIMIZE_BREAKPOINT_SIZE) || 1024,
	TOKEN_KEY: STORAGE_KEYS.TOKEN,
	ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY || 'StichMaster#SecureKey@2026_Secret!',
	IS_DEV: process.env.NODE_ENV === 'development',
	IS_PROD: process.env.NODE_ENV === 'production',
	FIREBASE: {
		API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBsh4OKrgv2g7yk2fHBTRWdIEYBec1u6M4',
		AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'amthi-erp.firebaseapp.com',
		PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'amthi-erp',
		STORAGE_BUCKET:
			process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'amthi-erp.firebasestorage.app',
		MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '675127168107',
		APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || '1:675127168107:web:096840c8c4d08e24ff752e',
		VAPID_KEY:
			process.env.REACT_APP_FIREBASE_VAPID_KEY ||
			'BFEiMcIIxrInfx6_3cyRcSj4Yf5BKzjrvZXe_zxzW_ANXX1kFDVInoo8BFag6ViVc3ZmYhRZCsg5QwY7sPFssq0',
	},
} as const;

export default ENV;

